import { useModal } from '@shape-ds/components';
import PermissionedButton from 'components/PermissionedButton/PermissionedButton';
import { useFeatureFlag } from '@shape/feature-flag';
import { AttachToCase } from 'pages/Asset/tabs/Cases/components/AttachCase/AttachToCase';
import { EventItem } from 'queries/events/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EventStatus } from '../../EventStatusModal';

interface AckButtonProps {
  event: EventItem;
  setSelectedRow?: (row?: EventItem) => void;
}

const AckButton: React.FC<AckButtonProps> = ({ event, setSelectedRow }) => {
  const { t } = useTranslation();
  const { openModal } = useModal();

  const modal = <AttachToCase selectedRow={event} />;

  return (
    <PermissionedButton
      buttonVariant={event.status === 'CLOSED' ? 'secondary' : 'primary'}
      onClick={() =>
        openModal(modal, {
          title: t(`event_page:components.modalAck.title.${event.status}`, {
            defaultValue: t(`event_page:components.modalAck.title.OPEN`),
          }),
          width: '680px',
        })
      }
    >
      {event.status === 'CLOSED'
        ? t('event_page:components.eventFooter.btns.reclassify')
        : t('event_page:components.eventFooter.btns.ack')}
    </PermissionedButton>
  );
};

export default AckButton;
